export default "__VITE_ASSET__CVMaXIXw__"